import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { DeleteStorymapCustomAiStoryTemplate } from '../../api/commands';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class DeleteCustomAiStoryTemplate extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'DeleteCustomAiStoryTemplate';

    public constructor(public templateId: string) {
        super(DeleteCustomAiStoryTemplate.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: DeleteCustomAiStoryTemplate): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new DeleteStorymapCustomAiStoryTemplate(action.templateId, state.id),
    });
};

const reducer = (state: StorymapState, action: DeleteCustomAiStoryTemplate): void => {
    // @ts-ignore
    state.customAiStoryTemplates = state.customAiStoryTemplates.filter((x) => x.id !== action.templateId);
};

//@ts-ignore
registerMiddleware(DeleteCustomAiStoryTemplate.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(DeleteCustomAiStoryTemplate.ACTION_TYPE, reducer);
